import { render, staticRenderFns } from "./Teen13.vue?vue&type=template&id=52d07136&scoped=true&"
import script from "./Teen13.vue?vue&type=script&lang=js&"
export * from "./Teen13.vue?vue&type=script&lang=js&"
import style0 from "./Teen13.vue?vue&type=style&index=0&id=52d07136&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d07136",
  null
  
)

export default component.exports